//import lossClient from "auth/lossClientInterceptor";
import {lossClient} from "api";
// import fetch from "auth/FetchInterceptor";

const MasterZipCodeService = {};

MasterZipCodeService.getProvinceCodeList = function (data) {
  return lossClient({
    url: `/MasterProvinsi/masterprovinsi`,
    method: "get",
  });
};

MasterZipCodeService.getCityCodeList = function (userInput) {
  return lossClient({
    url:
      "/ZipCode/search?pageSize=100000&pageIndex=0&province=" +
      userInput.codeProv,
    method: "get",
  });
};

MasterZipCodeService.getDistrictCodeList = function (userInput) {
  return lossClient({
    url:
      "/ZipCode/search?pageSize=100000&pageIndex=0&city=" +
      userInput.codeCity +
      "&province=" +
      userInput.codeProv,
    method: "get",
  });
};

MasterZipCodeService.getVillageCodeList = function (userInput) {
  return lossClient({
    url:
      "/ZipCode/search?pageSize=100000&pageIndex=0&kecamatan=" +
      userInput.codeKecmtn +
      "&city=" +
      userInput.codeCity +
      "&province=" +
      userInput.codeProv,
    method: "get",
  });
};

MasterZipCodeService.getPostalCodeList = function (userInput) {
  return lossClient({
    url:
      "/ZipCode/search?pageSize=100000&pageIndex=0&kelurahan=" +
      userInput.codeKelrhn +
      "&kecamatan=" +
      userInput.codeKecmtn +
      "&city=" +
      userInput.codeCity +
      "&province=" +
      userInput.codeProv,
    method: "get",
  });
};

MasterZipCodeService.getLegalCodeList = function (userInput) {
  return lossClient({
    url:
      "/TOJKKabupatenKota/search?pageIndex=0&pageSize=1000&provinsiid=" +
      userInput.codeProv,
    method: "get",
  });
};

export default MasterZipCodeService;
